import { GET_ORDER_DETAIL, SET_PAGE_LOADING } from './orderDetailConstants';

import { getOrderDetailApi } from '../../../api/order';
import { getMessage } from '../../messageOption/messageOptionActions';

export const setLoading = (isLoading) => {
  return {
    type: SET_PAGE_LOADING,
    payload: { isLoading }
  };
};

export const getOrderDetail = (orderIds, fromPage) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    let detail = null;
    getOrderDetailApi({ id: orderIds })
      .then(async (res) => {
        detail = Array.isArray(res.result)
            ? res.result[0]
            : res.result;
        dispatch({
          type: GET_ORDER_DETAIL,
          payload: detail
        });
        if (!fromPage) {
          await dispatch(getMessage(detail, false));
          dispatch(setLoading(false));
        }
      })
      .catch(() => {
        dispatch(setLoading(false));
      })
      .finally(() => {
        if (fromPage) {
          dispatch(setLoading(false));
        }
      });
  };
};
